import styled from 'styled-components';

export const GameJackpotBarContributionWrapperBox = styled.div<{isMobilePortrait?: boolean}>`
    width: ${({isMobilePortrait}) => isMobilePortrait ? '100%' : 'fit-content'};
    display: flex;
    justify-content: center;
`;